export default {
    SET_PLAN_DETAILS_BEGIN: 'SET_PLAN_DETAILS_BEGIN',
    SET_PLAN_DETAILS_SUCCESS: 'SET_PLAN_DETAILS_SUCCESS',
    SET_PLAN_DETAILS_ERROR: 'SET_PLAN_DETAILS_ERROR',
    SET_PLAN_DETAILS_CLEANUP: 'SET_PLAN_DETAILS_CLEANUP'
  };